export const Roles = {
    OrgAdmin: "org-admin",
    OrgUser: "org-user",
    Teacher: "teacher",
    Student: "student",
    Tutor: "tutor"
};